<template>
    <fragment>
        <InsideHeader :title="pageData.title" :bredcrumb="breadcrumb" />
        <section id="faq" class="faq-area faq-page-area bg-white">

            <div class="dd-bubbles">
                <img class="bubble slow" src="../../public/img/all-effect-img/Bog-Blob.svg" id="blue-side-bubble-11" alt="b">
            </div>

            <div class="container">
                <div class="row faq-wrapper">
                    <div class="col-12">
                        <div class="section-title-area">
                            <h2 class="section-heading text-center">{{ pageData.page_heading }}</h2>
                        </div>
                    </div>
                    
                    <div class="col-12">
                        <FAQList :faqData="faqData" />
                    </div>
                </div>
            </div>
        </section>
    </fragment>
</template>

<script>
import InsideHeader from "../components/InsideHeader.vue";
import FAQList from "../components/Faq/List"

export default {
    components: {
        InsideHeader, FAQList
    },
    data(){
        return {
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: this.$route.name, path:'#'}
            ],
            faqData: [],
            pageData: []
        }
    },
    methods: {
        getData(){            
            this.$http.get(`/faq`).then(res=>{                       
                if(res.status === 200 && res.data){
                    
                    if(res.data.page_data)
                        this.pageData = res.data.page_data
                    if(res.data.result)
                        this.faqData = res.data.result
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>